import { render } from "./Box.vue?vue&type=template&id=18139aac&scoped=true&ts=true"
import script from "./Box.vue?vue&type=script&lang=ts"
export * from "./Box.vue?vue&type=script&lang=ts"

import "./Box.vue?vue&type=style&index=0&id=18139aac&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18139aac"]])

export default __exports__